import { gql, useMutation } from "@apollo/client";
import { useCallback } from "react";
import { GetAllFranchiseesQuery } from "./useAllFranchisees.ts";
import { TeacherRole, TeacherTag } from "../gql/graphql.ts";

const CreateFranchiseeMutation = gql`
  mutation createFranchisee(
    $email: String!
    $familyName: String!
    $givenName: String!
    $phoneNumber: PhoneNumberInput!
    $userGroupIds: [String!]
    $lesson1on1: Boolean
    $internalTeacher: Boolean
    $roles: [TeacherRole!]
    $tags: [TeacherTag!]
  ) {
    createFranchisee(
      email: $email
      familyName: $familyName
      givenName: $givenName
      phoneNumber: $phoneNumber
      userGroupIds: $userGroupIds
      lesson1on1: $lesson1on1
      internalTeacher: $internalTeacher
      roles: $roles
      tags: $tags
    ) {
      id
    }
  }
`;

export function useCreateFranchisee() {
  const [createFranchiseeMutation, { loading }] = useMutation(
    CreateFranchiseeMutation,
    {
      refetchQueries: [GetAllFranchiseesQuery],
    },
  );

  const createFranchisee = useCallback(
    async (variables: {
      email: string;
      givenName: string;
      familyName: string;
      phoneNumber: {
        countryCode: string;
        number: string;
      };
      userGroupIds?: string[];
      lesson1on1?: boolean;
      internalTeacher?: boolean;
      roles?: TeacherRole[];
      tags?: TeacherTag[];
    }) => {
      await createFranchiseeMutation({
        variables,
      });
    },
    [createFranchiseeMutation],
  );

  return {
    createFranchisee,
    loading,
  };
}
